import { LitElement, html, nothing, type TemplateResult } from "lit";

import { customElement, property, state } from "lit/decorators.js";

import "@phosphor-icons/webcomponents/PhPlus";

import { styles } from "./manage-create-launcher.css";

import "../manage-create-modal/manage-create-modal";
import type { DirectiveResult } from "lit/async-directive.js";

@customElement("manage-create-launcher")
export class ManageCreateLauncher extends LitElement {
  @state() private showManageCreateModal = false;

  static override styles = styles;

  @property({ type: Object })
  createManageOptions!: {
    header: DirectiveResult;
    links: {
      label: DirectiveResult;
      description: DirectiveResult;
      href: string;
      icon: TemplateResult;
    }[];
  };

  private handleManageCreateModalOpen() {
    this.showManageCreateModal = true;
  }

  private handleManageCreateModalClose() {
    this.showManageCreateModal = false;
  }

  private showManageCreateButton() {
    return html`
      <button class="launcher-button" @click=${this.handleManageCreateModalOpen}>
        <ph-plus size="24"></ph-plus>
        <span>Create</span>
      </button>
    `;
  }

  override render() {
    return html`${this.showManageCreateButton()}
    ${this.showManageCreateModal
      ? html`
          <manage-create-modal
            .manageCreateModalItems=${this.createManageOptions.links}
            @manage-create-modal-close=${this.handleManageCreateModalClose}
          >
            <span slot="header">${this.createManageOptions.header}</span>
          </manage-create-modal>
        `
      : nothing}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "manage-create-launcher": ManageCreateLauncher;
  }
}
